import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { PaymentGatewayFormContext } from 'context';
import type {
  ComponentMode,
  PaymentGateway as PaymentGatewayConfig,
} from 'types';

import { PaymentGatewayForm, PaymentGatewayHeader } from './components';

type PaymentGatewayProps = {
  mode: ComponentMode;
};

export default function PaymentGateway({ mode }: PaymentGatewayProps) {
  const data = useLoaderData() as PaymentGatewayConfig | undefined;

  const { title: paymentGatewayTitle } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode
    ? paymentGatewayTitle
    : 'افزودن درگاه پرداخت جدید';
  const defaultTitle = isUpdatedMode ? paymentGatewayTitle : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <PaymentGatewayHeader>{title}</PaymentGatewayHeader>
      <PaymentGatewayFormContext
        mode={mode}
        defaultTitle={defaultTitle}
        ownerType='Config'
        {...(isUpdatedMode ? data : {})}
      >
        <PaymentGatewayForm />
      </PaymentGatewayFormContext>
    </React.Fragment>
  );
}
